import PhotosSummaryCard from "./PhotosSummaryCard";
export default PhotosSummaryCard;
